document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-swiper-thumbs').forEach(function (section) {
    var swiperEl = section.querySelector('.swiper-thumbs-main .swiper');
    if (!swiperEl) return;

    var tabItems = section.querySelectorAll('.swiper-thumbs-tab-item');
    var tabPanels = section.querySelectorAll('.swiper-thumbs-tab-panel');

    var slidesCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (!slidesCount) return;

    // 每个 origin 第一次出现的物理 slide 下标（tab 点击跳转目标）
    var originPrimaryIndex = {};
    swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach(function (slide, i) {
      var origin = slide.getAttribute('data-origin-index');
      if (origin !== null && originPrimaryIndex[origin] === undefined) {
        originPrimaryIndex[origin] = i;
      }
    });

    function getOriginIndex(swiperInstance) {
      var activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return swiperInstance.realIndex;
      var origin = activeSlide.getAttribute('data-origin-index');
      return origin !== null ? parseInt(origin, 10) : swiperInstance.realIndex;
    }

    function updateTab(index) {
      tabItems.forEach(function (item, i) {
        item.classList.toggle('active', i === index);
      });
      tabPanels.forEach(function (panel, i) {
        panel.classList.toggle('active', i === index);
      });
    }

    function manageVideos(swiperInstance) {
      swiperInstance.slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
      var activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (activeSlide) {
        var activeVideo = activeSlide.querySelector('video');
        if (activeVideo) activeVideo.play().catch(function () {});
      }
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20,
      loop: slidesCount > 1,
      loopedSlides: slidesCount,
      speed: 500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChangeTransitionEnd: function () {
          updateTab(getOriginIndex(this));
          manageVideos(this);
        },
        afterInit: function () {
          if (slidesCount > 1) {
            this.slideToLoop(0, 0);
          }
          updateTab(0);
          manageVideos(this);
        },
      },
    });

    tabItems.forEach(function (item, i) {
      item.addEventListener('click', function () {
        var targetIndex = originPrimaryIndex[i];
        if (targetIndex === undefined) return;
        if (getOriginIndex(swiper) === i) return;

        swiper.slideToLoop(targetIndex, 500);
        updateTab(i);
        if (swiper.autoplay && swiper.autoplay.running) {
          swiper.autoplay.stop();
          swiper.autoplay.start();
        }
      });
    });
  });
});
